(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jsfitsio", [], factory);
	else if(typeof exports === 'object')
		exports["jsfitsio"] = factory();
	else
		root["jsfitsio"] = factory();
})(this, () => {
return 